import { isProduction } from "./environment";

function getCDNImageUrl(imageName: string) {
  // Production uses production URL, everything else uses staging
  if (isProduction) {
    return `https://cdn.zapier.com/zapier/images/${imageName}`;
  }

  // Everything else (dev, staging, preview) uses staging
  return `https://cdn.zapier-staging.com/zapier/images/${imageName}`;
}

export default getCDNImageUrl;
